/**
 * 这里是因为在可编辑的dps周报截图的时候，html2canvas这玩意儿读取到node节点的宽度偏小，所以在onclone回调内 强制纠正
 * html2canvas这玩意儿 不知道什么原因 会丢失 width、height、padding这些样式，需要在onclone回调里 再赋值一遍，不然下载下来的东西 跟 页面展示的不一样
 */
export function handleCaptureNodeClone(node?: React.RefObject<HTMLDivElement | null>, element?: HTMLElement) {
  if (!element || !node?.current) return;
  element.style.paddingTop = getComputedStyle(node.current).getPropertyValue('padding-top');
  element.style.width = getComputedStyle(node.current).getPropertyValue('width');
  element.style.height = getComputedStyle(node.current).getPropertyValue('height');
}
